import { useEffect } from 'react';
import { CUSTOM_EVENTS } from '~/common/constants/events';
import { CookieService } from '~/common/utils/cookies';

export const useGTMConsent = () => {
  useEffect(() => {
    const syncConsentToGTM = () => {
      if (typeof window.gtag !== 'function') {
        window.gtag = function gtag(...args: any[]) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(args);
        };
      }

      const state = CookieService.getConsent();
      const hasValidConsent =
        state !== null && !CookieService.isConsentExpired(state);
      const analyticsGranted = hasValidConsent && state!.analytics;
      const marketingGranted = hasValidConsent && state!.marketing;
      const functionalityGranted = hasValidConsent && state!.functionality;

      window.gtag('consent', 'update', {
        analytics_storage: analyticsGranted ? 'granted' : 'denied',
        ad_storage: marketingGranted ? 'granted' : 'denied',
        ad_user_data: marketingGranted ? 'granted' : 'denied',
        ad_personalization: marketingGranted ? 'granted' : 'denied',
        functionality_storage: functionalityGranted ? 'granted' : 'denied',
      });

      // Loading is owned by GoogleTagManagerHead (Consent Mode advanced); this is a no-op safety
      // net for the case where the inline snippet ran before this hook mounted.
      window?.__loadGTM?.();
    };

    syncConsentToGTM();

    const handleConsentUpdate = () => {
      syncConsentToGTM();
    };

    window.addEventListener(
      CUSTOM_EVENTS.cookieConsentUpdated,
      handleConsentUpdate,
    );

    return () => {
      window.removeEventListener(
        CUSTOM_EVENTS.cookieConsentUpdated,
        handleConsentUpdate,
      );
    };
  }, []);
};
